import { useEffect } from 'react';

const useLockBody = (locked) => {
  useEffect(() => {
    if (locked) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [locked]);

  return;
};

export default useLockBody;
